export const driverDrivesColumns = [
	{
		title: 'Start date',
		name: 'Start_date',
		driverDriveKey: 'start_date_timestamp',
		hide: false,
		type: 'DATETIME',
	},
	{
		title: 'Stop date',
		name: 'Stop_date',
		driverDriveKey: 'end_date_timestamp',
		hide: false,
		type: 'DATETIME',
	},
	{
		title: 'Avg speed',
		name: 'Avg_speed',
		driverDriveKey: 'average_speed',
		hide: false,
		type: 'STRING',
	},
	{
		title: 'Vehicle',
		name: 'Vehicle',
		driverDriveKey: 'external_id',
		hide: false,
		type: 'STRING',
	},
	{
		title: 'Start address',
		name: 'Start_address',
		driverDriveKey: 'start_address',
		hide: false,
		type: 'STRING',
	},
	{
		title: 'Stop address',
		name: 'Stop_address',
		driverDriveKey: 'stop_address',
		hide: false,
		type: 'STRING',
	},
	{
		title: 'Distance',
		name: 'Distance',
		driverDriveKey: 'distance_in_meters',
		hide: false,
		type: 'STRING',
	},
	{
		title: 'Duration',
		name: 'Duration',
		driverDriveKey: 'duration',
		hide: false,
		type: 'STRING',
	},
	{
		title: 'Drive Id',
		name: 'Drive_Id',
		driverDriveKey: 'driveId',
		hide: false,
		disableOption: true,
		type: 'STRING',
	},
]
